import apiClient from "./axiosConfig";

const url = "/chats/recommendations";

export const recommendationService = {
  // Create a new recommendation
  async createRecommendation(data) {
    const res = await apiClient.post(url + "/", data);
    return res.data;
  },

  // Get all recommendations (filtered by role)
  async getAll() {
    const res = await apiClient.get(url + "/");
    return res.data;
  },

  // Get recommendations received by professional
  async getReceived() {
    const res = await apiClient.get(url + "/received/");
    return res.data;
  },

  // Get recommendations sent by recruiter
  async getSent() {
    const res = await apiClient.get(url + "/sent/");
    return res.data;
  },

  // Get single recommendation details
  async getDetail(id) {
    const res = await apiClient.get(`${url}/${id}/`);
    return res.data;
  },

  // Mark recommendation as viewed by professional
  async markViewed(id) {
    const res = await apiClient.post(`${url}/${id}/mark_viewed/`);
    return res.data;
  },

  // Mark recommendation as clicked (when professional opens job details)
  async markClicked(id) {
    const res = await apiClient.post(`${url}/${id}/mark_clicked/`);
    return res.data;
  },

  // Mark recommendation as shared by professional
  async markShared(id) {
    const res = await apiClient.post(`${url}/${id}/mark_shared/`);
    return res.data;
  },

  // Create a shareable link for a recommendation
  async createShare(recommendationId, channel, recipientId = null) {
    const res = await apiClient.post(url + "/share/", {
      recommendation_id: recommendationId,
      channel: channel,
      recipient_id: recipientId,
    });
    return res.data;
  },

  // Get stats for a recommendation (recruiter only)
  async getStats(id) {
    const res = await apiClient.get(`${url}/stats/${id}/`);
    return res.data;
  },

  // Get public recommendation via share token (no auth required)
  async getPublic(token) {
    const res = await apiClient.get(`/chats/shared/${token}/`);
    return res.data;
  },
};
